/**
 * Fotos encima del título del chat tipo Crisp.
 * Ramiro: Gravatar para ramiro@wembii.com (sin foto en Gravatar → iniciales en azul Wembii).
 * Otros rostros: placeholders hasta enlazar equipo real desde Soporte Wembii.
 * Logo en el último disco: favicon en /public (sustituible por PNG de marca).
 */

/** MD5 de `ramiro@wembii.com` en minúsculas (estándar Gravatar). */
const RAMIRO_GRAVATAR_MD5 = "bb219a5412235b979a4c1ed645c3f3fe";

const ramiroFallback = encodeURIComponent(
  "https://ui-avatars.com/api/?name=Ramiro&size=192&background=0d4b7e&color=ffffff"
);

export const SUPPORT_CHAT_RAMIRO_AVATAR = `https://www.gravatar.com/avatar/${RAMIRO_GRAVATAR_MD5}?s=192&r=pg&d=${ramiroFallback}`;

/** Rostros demo (sustituir por Soporte cuando existan). */
export const SUPPORT_CHAT_TEAM_FACE_2 = "https://i.pravatar.cc/208?img=47";
export const SUPPORT_CHAT_TEAM_FACE_3 = "https://i.pravatar.cc/208?img=12";

export function supportChatPublicLogoUrl(): string {
  const base = typeof process.env.PUBLIC_URL === "string" ? process.env.PUBLIC_URL : "";
  return `${base}/favicon.png`;
}
